// router
import { Navigate, useRoutes } from "react-router-dom";
import { MainLayout } from "components/layouts/dashboard";
import { paths } from "./paths";
// components
import {
  AuthLogin,
  ApplicationsList,
  ApplicationsLeave,
  ApplicationsLoan,
  ApplicationsMission,
  ApplicationsCertificate,
  Home,
  Calendar,
  ApplicationsDetails,
  PendingActionsList,
  PendingActionsApprove,
  NotFound,
  Profile,
  Settings,
  Notifications,
  ForgetPassword,
  ApplicationsSalaryAllowance,
  ApplicationOvertime,
  EmployeeActionWarning,
  EmployeeActionAppreciation,
  EmployeeActionList,
  MessagesList,
  MessageDetail,
  Dashboard,
  TeamStatistics,
  LeaveHeatmap,
  PublicCalendar,
  MeetingRoom,
  AnnouncementsList,
  AnnouncementsCreate,
  AnnouncementsDetail,
  SurveysList,
  SurveysCreate,
  SurveysDetail,
  SurveysSubmit,
  SurveysResults,
  AttendanceToday,
  AttendanceReport,
  AttendanceTeamToday,
  AttendanceTeamReport,
  TrainingList,
  TrainingCreate,
  TrainingDetail,
  TrainingMyEnrollments,
  UsersList,
  UsersCreate,
} from "./elements";
// layouts
import { AuthLayout, PagesLayout } from "components/layouts";
// guards
import { AuthGuard } from "features/guards";

export const Router = () => {
  return useRoutes([
    {
      path: paths.root,
      element: <Navigate to={paths.root} replace />,
    },
    {
      path: paths.auth.root,
      element: <AuthLayout />,
      children: [
        { element: <Navigate to={paths.auth.login} />, index: true },
        {
          path: paths.auth.login,
          element: <AuthLogin />,
        },
        {
          path: paths.auth.forgetPassword,
          element: <ForgetPassword />,
        },
        // {
        //   path: paths.auth.resetPassword,
        //   element: <ResetPassword />,
        // },
      ],
    },
    {
      path: paths.root,
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          element: <Dashboard />,
          index: true,
        },
        { path: paths.dashboard, element: <Dashboard /> },
        { path: paths.applications.list, element: <ApplicationsList /> },
        { path: paths.calendar.calendar, element: <Calendar /> },
        { path: paths.leaveHeatmap, element: <LeaveHeatmap /> },
        { path: paths.publicCalendar, element: <PublicCalendar /> },
        { path: paths.pendingActions.list, element: <PendingActionsList /> },
        { path: paths.messages.list, element: <MessagesList /> },
        { path: paths.messages.detail, element: <MessageDetail /> },
        { path: "/team-statistics", element: <TeamStatistics /> },
        { path: paths.meetingRoom, element: <MeetingRoom /> },
        { path: paths.announcements.list, element: <AnnouncementsList /> },
        { path: paths.announcements.create, element: <AnnouncementsCreate /> },
        { path: paths.announcements.detail, element: <AnnouncementsDetail /> },
        { path: paths.surveys.list, element: <SurveysList /> },
        { path: paths.surveys.create, element: <SurveysCreate /> },
        { path: paths.surveys.detail, element: <SurveysDetail /> },
        { path: paths.surveys.submit, element: <SurveysSubmit /> },
        { path: paths.surveys.results, element: <SurveysResults /> },
        { path: paths.attendance.today, element: <AttendanceToday /> },
        { path: paths.attendance.report, element: <AttendanceReport /> },
        { path: paths.attendance.teamToday, element: <AttendanceTeamToday /> },
        { path: paths.attendance.teamReport, element: <AttendanceTeamReport /> },
        { path: paths.training.list, element: <TrainingList /> },
        { path: paths.training.create, element: <TrainingCreate /> },
        { path: paths.training.detail, element: <TrainingDetail /> },
        { path: paths.training.myEnrollments, element: <TrainingMyEnrollments /> },
        { path: paths.users.list, element: <UsersList /> },
        { path: paths.users.create, element: <UsersCreate /> },
      ],
    },
    {
      path: paths.applications.root,
      element: (
        <AuthGuard>
          <PagesLayout />
        </AuthGuard>
      ),
      children: [
        { element: <ApplicationsList />, index: true },
        {
          path: paths.applications.root,
          children: [
            { path: paths.applications.leave, element: <ApplicationsLeave /> },
            { path: paths.applications.loan, element: <ApplicationsLoan /> },
            {
              path: paths.applications.salaryAllowance,
              element: <ApplicationsSalaryAllowance />,
            },
            {
              path: paths.applications.mission,
              element: <ApplicationsMission />,
            },
            {
              path: paths.applications.certificate,
              element: <ApplicationsCertificate />,
            },
            {
              path: paths.applications.leaveEdit,
              element: <ApplicationsLeave />,
            },
            { path: paths.applications.loan, element: <ApplicationsLoan /> },
            {
              path: paths.applications.loanEdit,
              element: <ApplicationsLoan />,
            },
            {
              path: paths.applications.salaryAllowanceEdit,
              element: <ApplicationsSalaryAllowance />,
            },
            {
              path: paths.applications.missionEdit,
              element: <ApplicationsMission />,
            },
            {
              path: paths.applications.certificateEdit,
              element: <ApplicationsCertificate />,
            },
            {
              path: paths.applications.overtime,
              element: <ApplicationOvertime />,
            },
            {
              path: paths.applications.overtimeEdit,
              element: <ApplicationOvertime />,
            },
            {
              path: paths.applications.details,
              element: <ApplicationsDetails />,
            },
            {
              path: paths.applications.employeeActionWarning,
              element: <EmployeeActionWarning />,
            },
            {
              path: paths.applications.employeeActionAppreciation,
              element: <EmployeeActionAppreciation />,
            },
            {
              path: paths.applications.employeeActionList,
              element: <EmployeeActionList />,
            },
          ],
        },
      ],
    },
    {
      path: paths.pendingActions.root,
      element: (
        <AuthGuard>
          <PagesLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: paths.pendingActions.approve,
          element: <PendingActionsApprove />,
        },
      ],
    },
    {
      path: paths.profile,
      element: (
        <AuthGuard>
          <PagesLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: paths.profile,
          element: <Profile />,
        },
      ],
    },
    {
      path: paths.settings,
      element: (
        <AuthGuard>
          <PagesLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: paths.settings,
          element: <Settings />,
        },
      ],
    },
    {
      path: paths.notifications,
      element: (
        <AuthGuard>
          <PagesLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: paths.notifications,
          element: <Notifications />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
};
